import styled from "@emotion/styled";
import Locked from "@engineering/icons/locked";
import User from "@engineering/icons/user";
import { Ui } from "@silvertours/front-shared";
var List = /*#__PURE__*/ styled("ul", {
    target: "e150qtw10"
})("padding:0 ", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";width:238px;*{font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";}");
var MembershipPanelWrapper = /*#__PURE__*/ styled("div", {
    target: "e150qtw11"
})("width:403px;");
var NavigationItem = /*#__PURE__*/ styled("li", {
    target: "e150qtw12"
})("padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, " 0;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";text-overflow:ellipsis;overflow-x:hidden;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}");
var StyledLink = /*#__PURE__*/ styled(Ui.TextLink, {
    target: "e150qtw13"
})(function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}");
var LockIcon = /*#__PURE__*/ styled(Locked, {
    target: "e150qtw14"
})("fill:currentcolor;width:1.5rem;height:1.5rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:none;}");
var UserIcon = /*#__PURE__*/ styled(User, {
    target: "e150qtw15"
})("display:none;fill:currentcolor;width:1.5rem;height:1.5rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}");
export { List, MembershipPanelWrapper, NavigationItem, StyledLink, LockIcon, UserIcon };
